<template>
    <div v-if="loaded">
        <design-2021-rubric-survey-show-component :rubric-survey-in="rubricSurvey">
            <template v-slot:tableButtons>
                <b-button
                    class="btn-add btn-add-module"
                    v-b-modal="'rubric-survey-show-module-add-students'"
                    variant="primary">
                    {{ $t('rubrics.add_students') }}
                </b-button>
            </template>
        </design-2021-rubric-survey-show-component>

        <design-2021-rubric-survey-show-module-add-student-modal-component
            :rubric-survey-in="rubricSurvey"></design-2021-rubric-survey-show-module-add-student-modal-component>
    </div>
</template>

<script>
import { ords } from '../../../../../app';

export default {
    name: 'design-2021-module-rubric-survey-show-component',
    props: ['rubricSurveyIn'],
    data() {
        return {
            rubricSurvey: null,
            loaded: false,
        };
    },
    mounted() {
        if (!this.loaded) {
            ords.use('rubricSurvey').add(this.rubricSurveyIn);

            ords.use('rubricSurvey')
                .with('rubric_survey_users', (rubricSurveyUserCallback) => {
                    rubricSurveyUserCallback.with('user');
                    rubricSurveyUserCallback.with('rubric_forms', (rubricFormCallback) => {
                        rubricFormCallback.with('rubric_form_results');
                    });
                    rubricSurveyUserCallback.with('peers', (peerCallback) => {
                        peerCallback.with(['user']);
                    });
                })
                .with('user')
                .find(this.rubricSurveyIn.id)
                .subscribe((rubricSurvey) => {
                    this.rubricSurvey = rubricSurvey;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped></style>
